<template>
  <div class="h-auto ml-0 w-full lg:mr-3 min-h-screen">
    <div class="bg-white m-3 rounded-md">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold">Team Leave Plan</p>
        <div class="flex justify-between items-baseline">
          <div class="text-sm flex-row">
            <label class="block pb-1">Search</label>
            <input
                v-model="searchInput"
                type="search"
                placeholder="Start typing to search..."
                class="bg-gray-200 w-52 py-1 rounded-md"
            />
          </div>
<!--          <div class="text-sm ml-5">
            <label class="block pb-1">Filter by Department </label>
            <el-select
                filterable
                class="bg-white rounded-full w-full border-none"
                :default-first-item="true"
                @change="filterLeavePlanForDepartment"
                placeholder="Select Department"
                v-model="departmentId"
            >
              <el-option
                  v-for="department in departments"
                  :key="department.Id"
                  :label="`${department.Name}`"
                  :value="department.Name"

              >
                {{
                  department.Name
                }}
              </el-option>
            </el-select>
          </div>-->
        </div>
      </div>
      <ve-table :columns="columns" :table-data="filteredLeavePlan" />
      <div
          v-if="!loading && filteredLeavePlan.length === 0"
          class="flex flex-col justify-center items-center h-full mt-5"
      >
        <el-empty :image-size="70" description="No Data"></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {mapGetters} from "vuex";
import decryptData from "@/utils/decrypt";
export default {

  data() {
    return {
      view: 'monthly',  // default view
      months: ['January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'],
      leavePlan: {},
      type:'team',
      loading:false,
      tableData: [],
      searchInput: "",
      departments: [],
      departmentId:"",
      teamLeavePlan:[]
    };
  },
  computed:{
    ...mapGetters(["getOrganization", "getToken"]),
    columns() {
      // Base columns for employee leave plan
      const baseColumns = [
        {
          field: "empNo",
          key: "empNo",
          title: "EMP No",
          renderBodyCell: ({ row }) => {
            return row.EmployeeNo;
          },
        },
        {
          field: "name",
          key: "name",
          title: "Employee Name",
          renderBodyCell: ({ row }) => {
            return decryptData(row.EmployeeName, this.$decryptionKey) ;
          },
        },
      ];

      // Dynamic month columns
      const monthColumns = this.months.map((month) => ({
        field: month,
        key: month,
        title: month,
        renderBodyCell: ({ row }) => {
          return row[month] || 0; // Show 0 if no leave days are planned
        },
      }));

      // Combine the base columns and dynamic month columns
      return [...baseColumns, ...monthColumns];
    },
    filteredLeavePlan(){
      return this.teamLeavePlan.filter((employee)=>{
        return  decryptData(employee.EmployeeName, this.$decryptionKey).toLowerCase().includes(this.searchInput.toLowerCase())
      })
    }
  },
  created() {
    this.getDepartments();
    this.getLeavePlan()
  },
  methods: {
    getLeavePlan(){
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(`${this.getOrganization}/timeoff/team/plan/${this.$ApiVersion}/request`,
          options)
          .then((response)=>{
            this.teamLeavePlan = response.data.Data
          }).catch((error)=>{
        console.log(error)
      })
    },
    setView(viewType) {
      this.view = viewType;
    },
    updatePlan(monthOrQuarter, days) {
      this.$set(this.leavePlan, monthOrQuarter, days);
    },
    filterLeavePlanForDepartment(departmentId) {
      this.departmentId = departmentId
    },
    getDepartments() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
          .get(
              `${this.getOrganization}/setup/department/${this.$ApiVersion}/request`,
              options
          )
          .then(
              (response) => {
                this.loading = false;
                if (response.data.StatusCode == 200) {
                  this.departments = response.data.Data;
                } else {
                  this.get_error = response.data.StatusMessage;
                }
              },
              (error) => {
                this.loading = false;
                this.get_error = error.message;
              }
          );
    },
  }
}
</script>
<style>
table tr th, table tr td {
  text-align: left;
}
table tr td span {
  color: #67c23a;
  font-weight: 700;
}
</style>